import { render, staticRenderFns } from "./vipPlanF.vue?vue&type=template&id=9a6497e2&scoped=true&"
import script from "./vipPlanF.vue?vue&type=script&lang=ts&"
export * from "./vipPlanF.vue?vue&type=script&lang=ts&"
import style0 from "./vipPlanF.vue?vue&type=style&index=0&id=9a6497e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6497e2",
  null
  
)

export default component.exports